import React, { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useHistory, useLocation } from 'react-router-dom';
import siteService from '../../services/siteService';
import { getJobApplicationDetails } from "../../redux/actions/JobActions"
import { CircularProgress } from '@material-ui/core';
import defaultBanner from '../../../assets/images/bg/default-banner.jpg';
import { Link } from "react-router-dom";
import CustomGoogleAdsense from '../shared/views/CustomGoogleAdsense';
import Sidebar from '../shared/views/Sidebar';
import createAccountImage from '../../../assets/images/pourquoi-creer-un-compte.jpg';
import ApplicationDetailComponent from '../admin/applications/ApplicationDetailComponent';
import { jobSearch } from "../../redux/actions/JobActions"


let EmployerApplicationDetail = (props) => {
    const { getJobApplicationDetails } = props;
    const [displayingJobList, setDisplayingJobList] = React.useState([]);
    const currentSite = siteService.getCurrentSite();
    const history = useHistory();
    const [isLoading, setIsLoading] = React.useState(true);
    const [jobId, setJobId] = React.useState("");
    const [jobApplicationDetails, setJobApplicationDetails] = React.useState(null);
    const [job, setJob] = React.useState("");
    const [sortedBy, setSortedBy] = React.useState("postedDate");


    useEffect(() => {
        let match = props.match;
        if (match !== undefined) {

            let params = match.params;
            if (params !== undefined && params.jobId !== undefined) {
                getJobApplicationDetails(params.jobId).then(response => {
                    setJobApplicationDetails(response);
                    setIsLoading(false);
                });
            }
        };
    }, []);


    return (
        <React.Fragment>
            <Helmet>
                <title> Offres d'emploi  | {currentSite.fullName}</title>
            </Helmet>
            {isLoading ? (
                <div className="loading-container">
                    <CircularProgress />
                    <div>Chargement des postulations en cours...</div>
                </div>
            ) : (
                <>
                    <div className="header-inner" style={{ background: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${defaultBanner})` }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <h2 style={{ color: "white" }}>Offres d'emploi</h2>
                                    <ol className="breadcrumb mb-0 p-0">
                                        <li className="breadcrumb-item"><Link to={"/"}>Accueil</Link>  </li>
                                        <li className="breadcrumb-item"><i className="fas fa-chevron-right"></i><a href="index.html"> Employeur </a></li>
                                        <li className="breadcrumb-item active"> <i className="fas fa-chevron-right"></i> <span> Offres d'emploi</span></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="space-ptb" style={{ paddingTop: "40px" }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-9 bg-light-3 px-4">
                                    <div className="job-filter my-4 d-sm-flex align-items-center">
                                        <div className="section-title mb-0">
                                            <h2 className="title"><span>{jobApplicationDetails.jobTitle}</span></h2>
                                        </div>
                                    </div>
                                    <div>
                                        <ApplicationDetailComponent jobApplicationDetails={jobApplicationDetails} />
                                    </div>
                                    <CustomGoogleAdsense location="Wide2" />
                                </div>
                                <div className="col-lg-3">
                                    <div className="sidebar">
                                        <Sidebar />
                                        <div className="widget border-0">
                                            <div className="jobster-company-view">
                                                <ul className="list-unstyled">
                                                    <li>
                                                        <div className="widget-box">
                                                            <div className="d-flex">
                                                                <div>
                                                                    <Link to={"/candidates/signup"}>
                                                                        <img className="img-fluid" src={createAccountImage} alt="" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <CustomGoogleAdsense location="Side1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </React.Fragment>
    )

}


EmployerApplicationDetail.propTypes = {
    getJobApplicationDetails: PropTypes.func.isRequired,
    jobSearch: PropTypes.func.isRequired,
    storeJob: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    getJobApplicationDetails: PropTypes.func.isRequired,
    jobSearch: PropTypes.func.isRequired,
    storeJob: state.job,
});

export default connect(mapStateToProps, { getJobApplicationDetails, jobSearch })(EmployerApplicationDetail)